module.exports = __webpack_public_path__ + "assets/52ef600fea5d428d81f9a51d82b90c1c.mp3";